import { glockeZahl } from "../mitteilungen";
import { Icon } from "../shell/Icon";
import s from "./ui.module.css";

/** Glocke mit der Zahl der ungelesenen Mitteilungen als Marke (KOPFZEILE.md, Abschnitt 3.3), in der Kopfzeile und in der unteren
 *  Leiste. Nur das Bild: Den Vorlesetext (glockeText) trägt der Knopf oder Link drumherum, die Marke ist für Screenreader versteckt. */
export function Glocke({ ungelesen, groesse = 22 }: { ungelesen: number; groesse?: number }) {
  return (
    <span className={s.glocke}>
      <Icon name="glocke" groesse={groesse} />
      {ungelesen > 0 ? (
        <span className={s.glockeZahl} aria-hidden="true">
          {glockeZahl(ungelesen)}
        </span>
      ) : null}
    </span>
  );
}
